








import {Component} from 'vue-property-decorator'
import {TabBase} from "@/views/Vozila/DetaljiVozila/TabBase";
import PregledPodsetnikaVozila from "@/views/Podsetnici/PregledPodsetnikaVozila.vue";

declare const $: any;

@Component({components: {'mf-podsetnik-vozila' : PregledPodsetnikaVozila}})
export default class Tab5 extends TabBase {

}
